module.exports = __webpack_public_path__ + "img/delete_video_af.953aa5ba.svg";